import { Observation } from "@medplum/fhirtypes";

import { LOINCAnswerCodes, LOINCCodes } from "@/fhir/enums/loinc";
import { Systems } from "@/fhir/enums/systems";

export type LaborStage =
  | LOINCAnswerCodes.SecondStageLabor
  | LOINCAnswerCodes.ActiveLabor
  | LOINCAnswerCodes.EarlyLabor
  | LOINCAnswerCodes.ProdromalLabor;

export const LaborStages = {
  [LOINCAnswerCodes.SecondStageLabor]: "2nd Stage Labor",
  [LOINCAnswerCodes.ActiveLabor]: "Active Labor",
  [LOINCAnswerCodes.EarlyLabor]: "Early Labor",
  [LOINCAnswerCodes.ProdromalLabor]: "Prodromal Labor",
};

export interface StageRow {
  time: string;
  observations: Observation[];
}

// Define a generic form values type for labor questionnaires
export type FormValues = Record<string, unknown>;

export const LABOR_STAGE_OBSERVATION_CRITERIA = (encounterId: string, clientId: string) =>
  `Observation?encounter=Encounter/${encounterId}&subject=Patient/${clientId}` +
  `&code=${Systems.LOINC}|${LOINCCodes.LaborStage}&_sort=-_lastUpdated`;
